import client from './client';

export interface OrgNode {
  id: string;
  nom: string;
  poste: string;
  department?: string;
  children: OrgNode[];
}

export interface OrganigrammeData {
  company_name: string;
  source: 'manual' | 'employees' | 'empty';
  organigramme: OrgNode | null;
}

export const structureApi = {
  getOrganigramme: () =>
    client.get<{ success: boolean; data: OrganigrammeData }>('/structure/organigramme'),
};
